module.exports = __webpack_public_path__ + "static/media/back_end_system.9e7235aa.png";